<template>
  <div class="form-group w-100">
    <label for="input-global">{{ propLabel }}
      <strong class="input-live-help">
        {{ propRequired ? ' *' : '' }}
      </strong></label>
    <b-form-input id="input-global"
                  v-model="value"                  
                  v-money="propMoney ? money : ''"         
                  class="form-control"
                  :placeholder="propPlaceholder"    
                  :required="propRequired"
                  :state="state"            
                  @input="handleChange($event)"
                  @blur="handleValidade" />
    <b-form-invalid-feedback id="input-live-feedback">
      {{ propErrorMensage }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
  // Imports
  import { VMoney } from 'v-money'
  import { moneyToNumber } from '../../utils/conversors'

  export default ({
    name: "InputGlobal",
    directives: {
      money: VMoney
    },
    props: {
      propPlaceholder: {type: String, default: ''},
      propLabel: {type: String, default: ''},
      propDataPropriedade: {type: String, default: null},
      propType: {type: String, default: 'text'},
      propValorInicial: {default: null},
      propMoney: {type: Boolean, default: false},
      propRequired: {type: Boolean, default: false},
      propErrorMensage: {type: String, default: 'Campo obrigatório'},
      propValidate: {type: String, default: null}
    },
    data () {
      return {
        value: '',
        state: null,
        validate: {
          obrigatorio (value) {
            if (value.length < 3) return false
            return true
          },
          dinheiro (value) {
            const newValue = moneyToNumber(value)
            if (newValue <= 0) return false
            return true
          }
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    computed: {

    },
    watch: {
      value () {
        this.state = null
      },
      state () {
        this.inputError()
      }
    },
    async created  () {
 
    },
    methods: {
      handleChange () {
        if (this.propMoney) {
          return this.$emit('setInputValue', moneyToNumber(this.value), this.propDataPropriedade)
        }
        this.$emit('setInputValue', this.value, this.propDataPropriedade)
      },
      handleValidade () {
        if (!this.propValidate) return
        const data = this.validate[this.propValidate](this.value)
        this.state = data
      },
      inputError () {
        this.$emit('inputError', this.state)
      }
    }
  })
</script>

<style>
.input-live-help {
  color: red
}

</style>